import { useMemo } from 'react'
import React from 'react'

interface Props {
	stringValue: string
}

export const NodeHtmlText = ({ stringValue }: Props) => {
	const html = useMemo(() => {
		return stringValue.replace(/\n/g, '<br>')
	}, [stringValue])

	return <div dangerouslySetInnerHTML={{ __html: html }} />
}
